import { Record, Map } from "immutable";

export default Record({
  isRemoveModalVisible: false,
  isEditModalVisible: false,
  meta: new (Record({
    all: 0,
    count: 0,
    limit: 100,
    currentPage: 0
  }))(),
  search: new (Record({
    uid: null
  }))(),
  loading: false,
  entities: new Map([]),
  results: []
});



// WEBPACK FOOTER //
// ./src/common/mediaCategories/mediaCategories.js